<template>
  <div class="modify-page">
    <navigation
      class="header"
      :theme="{
        background: '#fff',
      }"
    >信息修改
    </navigation>
    <div
      class="form-container"
      v-if="configs.subjects"
    >

      <div class="divider"></div>
      <div class="step-title">
        <img src="./images/img_step01@2x.png">
        <template v-if="configs.subjects.includes('MOBILE')">
          <h2>修改信息项：登录手机号</h2>
          <p>信息资料仅用于信用与额度评估，请依照您的实际情况填写，确保信息真实可靠。</p>
        </template>
      </div>

      <van-form
        ref="form"
        onsubmit="return false;"
      >
        <template v-if="configs.subjects.includes('MOBILE')">
          <van-field
            readonly
            clickable
            name="picker"
            :value="form.mobileChangeInfo.mobileChangeReasonDesc"
            label="手机号修改原因"
            :rules="[{ required: true, message: '请选择修改原因' }]"
            placeholder="请选择"
            @click="showReason = true"
            class="field2cell van-form-item"
          >
            <van-icon
              name="arrow"
              slot="right-icon"
            />
          </van-field>
          <van-field
            clickable
            name="picker"
            v-model="form.mobileChangeInfo.mobile"
            label="新手机号确认"
            placeholder="请输入新手机号"
            class="field2cell van-form-item"
            maxlength="11"
            type="tel"
            :rules="[{ required: true, message: '请输入新手机号' }, { pattern: /^1[0-9]{10}$/, message: '请输入正确的手机号' }]"
          />
        </template>

        <template v-if="configs.needProvide.includes('REAL_NAME_SCREEN')">
          <div class="divider"></div> 
          <div class="auth-phone">
            <h3>新手机号运营商实名认证</h3>
            <div class="upload">
              <div class="item-example item"><img src="./images/img_a@2x.png"></div>
              <div class="upload-container item">
                <van-uploader
                  v-model="REAL_NAME_SCREEN"
                  :max-count="1"
                  :max-size="10 * 1024 * 1024" 
                  @oversize="onOversize"
                  :after-read="(e)=>afterRead(e,'REAL_NAME_SCREEN')"
                  accept="image/*"
                  class="van-uploader-item"
                >
                  <img
                    src="./images/img_b@2x.png"
                    class="upload-bg"
                  >
                </van-uploader>
              </div>
            </div>
          </div>
        </template>
        <div class="divider"></div>

        <template v-if="configs.subjects.includes('CONTACTS')">

          <div class="step-title">
            <h2>修改信息项：联系人信息</h2>
            <p>信息资料仅用于信用与额度评估，请依照您的实际情况填写，确保信息真实可靠。</p>
          </div>

          <van-field
            readonly
            clickable
            name="picker"
            :value="form.contactsChangeReasonDesc"
            label="联系人修改原因"
            :rules="[{ required: true, message: '请选择修改原因' }]"
            placeholder="请选择"
            @click="showReasonContact = true"
            class="field2cell van-form-item no-border"
          >
            <van-icon
              name="arrow"
              slot="right-icon"
            />
          </van-field>

          <div class="divider"></div>

     
          <div class="contact-list">
            <div class="contact-title">
              <img src="./images/icon_lianxiren1@2x.png">
              <span>联系人1</span>
            </div>

            <van-field
              readonly
              clickable
              name="picker"
              :value="form.relation1.relationDesc"
              label="亲属"
              :rules="[{ required: true, message: `请选择亲属` }]"
              placeholder="请选择"
              @click="showship1 = true"
              class="field2cell van-form-item "
            >
              <van-icon
                name="arrow"
                slot="right-icon"
              />
            </van-field>

            <van-field
              clickable
              name="picker"
              v-model="form.relation1.name"
              label="姓名"
              placeholder="请填写姓名"
              class="field2cell van-form-item"
              maxlength="10"
              :rules="[{ required: true, message: '请填写姓名' }, { pattern: /^[a-zA-Z]{2,10}$|^[\u4E00-\u9FA5]{2,10}$/, message: '请填写正确的姓名' }]"
            />

            <van-field
              clickable
              name="picker"
              v-model="form.relation1.mobile"
              label="手机号"
              placeholder="请填写手机号"
              class="field2cell van-form-item"
              maxlength="11"
              type="tel"
              :rules="[{ required: true, message: '请填写手机号' }, { pattern: /^1[0-9]{10}$/, message: '请填写正确的手机号' }]"
            />

            <div class="contact-title">
              <img src="./images/icon_lianxiren1@2x.png">
              <span>联系人2</span>
            </div>
            <van-field
              readonly
              clickable
              name="picker"
              :value="form.relation2.relationDesc"
              label="朋友"
              :rules="[{ required: true, message: `请选择朋友` }]"
              placeholder="请选择"
              @click="showship2 = true"
              class="field2cell van-form-item "
            >
              <van-icon
                name="arrow"
                slot="right-icon"
              />
            </van-field>

            <van-field
              clickable
              name="picker"
              v-model="form.relation2.name"
              label="姓名"
              placeholder="请填写姓名"
              class="field2cell van-form-item"
              maxlength="10"
              :rules="[{ required: true, message: '请填写姓名' }, { pattern: /^[a-zA-Z]{2,10}$|^[\u4E00-\u9FA5]{2,10}$/, message: '请填写正确的姓名' }]"
            />
         
            <van-field
              clickable
              name="picker"
              v-model="form.relation2.mobile"
              label="手机号"
              placeholder="请填写手机号"
              class="field2cell van-form-item"
              maxlength="11"
              type="tel"
              :rules="[{ required: true, message: '请填写手机号' }, { pattern: /^1[0-9]{10}$/, message: '请填写正确的手机号' }]"
            />

            
          </div>
        </template>
      </van-form>
      <nd-button
        class="btn"
        :disabled="isDisabled"
        :loading="loading"
        @click="next"
      >下一步</nd-button>
    </div>
    <!-- 弹层 -->
    <choose-pop
      :data="mobileChangeReason"
      v-model="showReason"
      :defaultValue="form.mobileChangeInfo.mobileChangeReason"
      :extendText="form.mobileChangeInfo.mobileChangeReasonDesc"
      :valueKey="['code', 'desc']"
      @change="reasonSelect"
      label="手机号修改原因"
    ></choose-pop>

    <choose-pop
      :data="contactsChangeReason"
      v-model="showReasonContact"
      :defaultValue="form.contactsChangeReason"
      :extendText="form.contactsChangeReasonDesc"
      :valueKey="['code', 'desc']"
      @change="contactsReasonSelect"
      label="联系人修改原因"
      extend
    ></choose-pop>
    <choose-pop
      :data="dictionary.relationship1"
      v-model="showship1"
      :defaultValue="form.relation1.relation"
      :valueKey="['key', 'description']"
      @change="familySelect"
      label="亲属"
    ></choose-pop>

    <choose-pop
      :data="dictionary.relationship2"
      v-model="showship2"
      :defaultValue="form.relation2.relation"
      :valueKey="['key', 'description']"
      @change="friendSelect"
      label="朋友"
    ></choose-pop>

  </div>
</template>


<script>
import { mapActions, mapState } from 'vuex'
import uploadMixins from '@/assets/uploadMixins'
import { getKey } from '../../../assets/utils'
export default {
  data () {
    return {
      loading: false,
      form: {
        mobile: this.$route.query.mobile,
        relation1: { name: '', relationDesc: '', relation: '', mobile: '' },
        relation2: { name: '', relationDesc: '', relation: '', mobile: '' },
        mobileChangeInfo: {
          mobileChangeReason: '',
          mobileChangeReasonDesc: '',
          mobile: ''
        },
        contactsChangeReason: '',
        contactsChangeReasonDesc: '',
        contactsChangeInfo: []
      },
      configs: {},
      isDisabled: !true,
      REAL_NAME_SCREEN: [],
      mobileChangeReason: [],
      contactsChangeReason: [],
      showReason: false,
      showReasonContact: false,
      showship1: false,
      showship2: false
    }
  },
  components: {
    choosePop: () => import('@/components/choose-pop')
  },
  mixins: [uploadMixins],
  async mounted () {
    await Promise.all([this.getReason(), this.fetchDictionaryX()]) 
    this.getConfig()
    this.$bus.$emit('ready')
  },

  computed: {
    showSendCode () {
      return true
    },
    ...mapState({
      dictionary: (state) => state.dictionary || {}
    })
  },
  methods: {
    ...mapActions('modify', ['getChangeConfig', 'userChangeReason', 'saveChange']),
    ...mapActions(['fetchDictionaryX']),
    async getConfig () {
      const { success, data } = await this.getChangeConfig()
      if (success) {
        this.configs = data || {}
        this.fillData(this.configs)
      }
    },
    // 资料回显
    fillData (data = {}) {
      if (data.mobileChangeInfo) {
        const { mobileChangeReason, otherReason, mobile } = data.mobileChangeInfo
        this.form.mobileChangeInfo.mobileChangeReason = mobileChangeReason
        this.form.mobileChangeInfo.mobileChangeReasonDesc = otherReason
        this.form.mobileChangeInfo.mobile = mobile
      }
      if (data.hasProvide?.length) {
        this.REAL_NAME_SCREEN = [{
          url: data.hasProvide[0].imageUrl,
          reqUrl: data.hasProvide[0].imageUrl
        }]
      }
      if (data.contactsChangeInfo?.length) {
        const { contactsChangeReason, otherReason } = data.contactsChangeInfo[0]
        this.form.contactsChangeReason = contactsChangeReason
        if (otherReason) {
          this.form.contactsChangeReasonDesc = otherReason
        }
        this.form.relation1 = { relationDesc: '', ...data.contactsChangeInfo[0] }
      }
      if (data.contactsChangeInfo?.length > 1) {
        this.form.relation2 = { relationDesc: '', ...data.contactsChangeInfo[1] }
      }
    },
    async getReason () {
      const { success, data } = await this.userChangeReason()

      if (success) {
        this.mobileChangeReason = data.mobileChangeReason || []
        this.contactsChangeReason = data.contactsChangeReason || []
      }
    },
    reasonSelect (val) {
      this.form.mobileChangeInfo.mobileChangeReason = val.value
      this.form.mobileChangeInfo.mobileChangeReasonDesc = val.name
    },
    contactsReasonSelect (val) {
      this.form.contactsChangeReason = val.value
      this.form.contactsChangeReasonDesc = val.name
    },

    familySelect (val) {
      this.form.relation1.relation = val.value
      this.form.relation1.relationDesc = val.name
    },
    friendSelect (val) {
      this.form.relation2.relation = val.value
      this.form.relation2.relationDesc = val.name
    },
    
    async next () {
      try {
        await this.$refs.form.validate()
        if (!this.REAL_NAME_SCREEN.length && this.configs.needProvide.includes('REAL_NAME_SCREEN')) {
          this.$message('请上传新手机号运营商实名认证图片')
          return
        }
        const { mobileChangeInfo } = this.form
        if (mobileChangeInfo?.mobileChangeReason === 'OTHER' && mobileChangeInfo?.mobileChangeReasonDesc) {
          mobileChangeInfo.otherReason = mobileChangeInfo.mobileChangeReasonDesc
        }

        const phoneNo = getKey('userInfo')?.mobile

        if (this.form.mobileChangeInfo.mobile === phoneNo) {
          this.$message('新手机号不能和原手机号相同')
          return
        }

        const params = {
          configNo: this.configs.configNo,
          mobileChangeInfo: mobileChangeInfo,
          contactsChangeInfo: []
        }
       
        const _cReason = {
          contactsChangeReason: this.form.contactsChangeReason
        }

        if (this.form.contactsChangeReason === 'OTHER') {
          _cReason.otherReason = this.form.contactsChangeReasonDesc
        }

        params.contactsChangeInfo.push({
          name: this.form.relation1.name,
          relation: this.form.relation1.relation,
          mobile: this.form.relation1.mobile,
          contactsSort: 'FIRST',
          ..._cReason
        })

        params.contactsChangeInfo.push({
          name: this.form.relation2.name,
          relation: this.form.relation2.relation,
          mobile: this.form.relation2.mobile,
          contactsSort: 'SECOND',
          ..._cReason
        })

        if (!this.configs.subjects.includes('CONTACTS')) {
          params.contactsChangeInfo = null
        }

        if (this.REAL_NAME_SCREEN?.length) {
          params.images = [ {
            imageType: 'REAL_NAME_SCREEN',
            url: this.REAL_NAME_SCREEN[0]?.reqUrl
          }]
        }
       

        this.loading = true
        const { success } = await this.saveChange({
          ...params
        })
        this.loading = false
        if (success) {
          this.$router.push('/modify/additional')
        }
      } catch (error) {
        console.log(error)
      }
    },

    async afterRead (file, type) {
      const fileList = await this.uploadImg(file, type)
      // this[type] = fileList
      console.log(fileList)
      console.log(this[type])
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.modify-page {
  min-height: 100vh;
  padding-bottom: 20px;

  .tips {
    margin-top: 60px;
  }

  .divider {
    border-top: 20px solid #f8f8f8;
    height: 0px;
    font-size: 0px;
  }

  .form-container {
    .auth-phone {
      padding: 30px 40px;
      h3 {
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .upload {
        display: flex;
        margin-top: 26px;
        justify-content: space-between;

        .van-uploader-item {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          /deep/.van-uploader__wrapper,
          /deep/.van-uploader__preview,
          /deep/.van-uploader__preview-image,
          /deep/.van-uploader__preview-imag img {
            position: absolute;
            width: 100%;
            height: 100%;
          }
          /deep/.van-uploader__preview-imag img {
            object-fit: cover;
          }
          /deep/.van-uploader__preview-delete {
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          }
          /deep/.van-uploader__preview-delete-icon {
            font-size: 50px;
            position: initial;
          }
        }
      }
      .item {
        width: 322px;
        height: 212px;
        position: relative;
        & > img,
        .upload-bg {
          width: 100%;
          height: 100%;
        }
      }
    }

    .contact-title {
      display: flex;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 45px;
      height: 44px;
      padding: 30px 40px;
      margin-bottom: 30px;

      img {
        margin-right: 15px;
        width: 44px;
        height: 44px;
      }
    }

    .step-title {
      display: flex;
      flex-direction: column;
      padding: 30px 40px;

      & > img {
        width: 670px;
        height: 76px;
      }

      h2 {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-top: 30px;
      }

      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-top: 15px;
      }

      span {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }

    .btn {
      margin: 80px auto;
    }

    .van-form-item {
      border-bottom: 1px solid #eee;
      padding: 30px 40px;

      &.no-border {
        border-bottom: none;
      }

      /deep/.van-cell__value {
        position: initial;

        .van-field__error-message {
          position: absolute;
          left: 40px;
        }
      }
    }
  }
}
</style>